export default {
    props: {},

    created(){
        this.init();
    },

    data(){
        let defaultData = this.getDefaultData();
        let modelsData = this.getModelsData();

        return _.merge( defaultData, modelsData );
    },

    computed: {
        // Override
        modelComponent(){
            return 'modelComponent';
        },

        resourceKey(){
            return 'Models';
        },

        url(){
            return '/api/models';
        },
    },

    watch: {
        archived(){
            this.init();
        }
    },

    filters: {},

    methods: {
        // Overrides
        afterSave( blocking = true ){
            this.init( blocking );
        },

        beforeLoad(){
            return Promise.resolve();
        },

        afterLoad( loadResults ){
            return Promise.resolve();
        },

        getDefaultData(){
            return {
                archived: false,

                loading: true,

                models: [],

                selectedModelId: null
            };
        },

        getModelsData(){
            return {};
        },

        setModels( response ){
            return this.$set( this, 'models', response.data[ this.resourceKey ] );
        },

        // Core
        init( blocking = true ){
            if( blocking ){
                this.loading = true;
            }

            return this.beforeLoad()
                .then( () => {
                    return this.load();
                } )
                .then( ( loadResults ) => {
                    return this.afterLoad( loadResults );
                } )
                .finally( () => {
                    this.loading = false;
                } )
                .catch( this.$root.handleErrors );
        },

        load(){
            let url = this.url;

            if( this.archived ){
                if( !url.includes( '?' ) ){
                    url += '?';
                }

                url += '&archived=true';
            }

            return axios.get( url )
                .then( ( response ) => {
                    this.setModels( response );
                } );
        },

        open( id ){
            this.selectedModelId = id;

            this.$nextTick( () => {
                this.$refs[ this.modelComponent ].openModal();
            } );
        },
    }
};